import { render, staticRenderFns } from "./HomeCard.vue?vue&type=template&id=3a82438e&scoped=true"
import script from "./HomeCard.vue?vue&type=script&lang=ts"
export * from "./HomeCard.vue?vue&type=script&lang=ts"
import style0 from "./HomeCard.vue?vue&type=style&index=0&id=3a82438e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a82438e",
  null
  
)

export default component.exports